<template>
    <div class="vendor-list-app h-100 d-flex flex-column">
        <div class="" :class="currentViewMode ? currentViewMode.headerContainerClass : 'container-xl'">
            <div class="row">
                <div class="col">
                
                <!-- <div class="h-100 d-flex flex-column"> -->
                    
                    <div class="w-100 mb-3 pt-4 d-flex gap-3 align-items-center justify-content-between">
                        <div class="d-flex gap-5 align-items-end">
                            <h1 class="mb-0">{{ $t('vendorListPage.title') }}</h1>
                            <div class="d-flex align-items-center">                            
                                <b-button v-for="vMode in viewModes" :key="vMode.key"
                                    :variant="currentViewMode && currentViewMode.key === vMode.key ? 'sharp-primary' : 'minimal-primary'"
                                    size="sm"
                                    :active="currentViewMode && currentViewMode.key === vMode.key"
                                    @click="setViewMode(vMode.key)"
                                >
                                    <b-icon :icon="vMode.icon" class="mr-1"></b-icon>
                                    <span class="button-text font-size-80">{{ vMode.i18nKey ? $t(vMode.i18nKey) : vMode.label }}</span>
                                </b-button>
                            </div>
                        </div>
                        <div class="">
                            <b-button
                                v-if="canAddVendor"
                                variant="success"
                                @click="onResourceNewModal('Vendor')"
                            >
                                <b-icon icon="plus-circle" class="mr-1"></b-icon>
                                {{ $t('vendorListPage.addVendor') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="currentViewMode" class="flex-fill" :class="currentViewMode ? currentViewMode.contentContainerClass : 'container-xl'">  <!-- LIST SECTION -->
            <div v-if="currentViewMode.key === 'advanced'" class="h-100 row">
                <div class="col h-100 pb-3">
                    <object-grid 
                        model-class="Company" 
                        class="h-100"
                        grid-max-height="100%"
                        :block-size="100"
                        colStateLocalStorageKey="vendorList"
                    ></object-grid>
                </div>
            </div>

            <div v-else-if="currentViewMode.key === 'basic'" class="h-100 row">
                <div class="col h-100">
                    <VendorList 
                        ref="basicList" 
                        class="h-100"
                        @request-create="onResourceNewModal('Vendor')"
                    />
                </div>
            </div>
            <div v-else-if="currentViewMode.key === 'map'" class="h-100">
                <VendorLocationMap class="h-100" />
            </div>
        </div>

                <!-- </div> -->
                <!-- </div>
            </div>
        </div> -->
        <ResourceModal ref="modal" @saved="onResourceSaved" />
    </div>
</template>

<script>
import ResourceModal from "@/components/resources/ResourceModal";
import VendorList from "@/components/vendors/components/VendorList";
import VendorLocationMap from '@/components/vendors/components/VendorLocationMap.vue';
import { currentUserInfoMixin, tenantInfoMixin } from '@/js/custom-vue-mixins';

const ADVANCED_VIEW_MODE = {
    position: 1,
    key: 'advanced',
    label: 'Advanced View',
    i18nKey: 'vendorListPage.advancedView',
    icon: 'grid-3x3-gap',
    headerContainerClass: 'container-fluid',
    contentContainerClass: 'container-fluid',
};
const BASIC_VIEW_MODE = {
    position: 2,
    key: 'basic',
    label: 'Basic View',
    i18nKey: 'vendorListPage.basicView',
    icon: 'list',
    headerContainerClass: 'container-xl',
    contentContainerClass: 'container-xl',
};
const MAP_VIEW_MODE = {
    position: 3,
    key: 'map',
    label: 'Map View',
    i18nKey: 'vendorListPage.mapView',
    icon: 'map',
    headerContainerClass: 'container-fluid',
    contentContainerClass: 'w-100',
};

export default {
    props: [],
    components: { 
        ResourceModal, 
        VendorList, 
        VendorLocationMap,
    },
    mixins: [currentUserInfoMixin, tenantInfoMixin],
    i18n: {  // NOTE: we need to make sure we inject VueI18n instance to the Vue instance to use this... needs work
        messages: {
            en: {
                vendorListPage: {
                    title: 'Vendors',
                    addVendor: 'Add Vendor',
                    advancedView: 'Advanced View',
                    basicView: 'Basic View',
                    mapView: 'Map View',
                },
            },
            es: {
                vendorListPage: {
                    title: 'Proveedores',
                    addVendor: 'Agregar Proveedor',
                    advancedView: 'Vista Avanzada',
                    basicView: 'Vista Básica',
                    mapView: 'Vista de Mapa',
                },
            },
            pt: {
                vendorListPage: {
                    title: 'Fornecedores',
                    addVendor: 'Adicionar Fornecedor',
                    advancedView: 'Vista Avançada',
                    basicView: 'Vista Básica',
                    mapView: 'Vista de Mapa',
                },
            },
            zh: {
                vendorListPage: {
                    title: '供应商',
                    addVendor: '添加供应商',
                    advancedView: '高级视图',
                    basicView: '基本视图',
                    mapView: '地图视图',
                },
            },
            'zh-Hans': {
                vendorListPage: {
                    title: '供应商',
                    addVendor: '添加供应商',
                    advancedView: '高级视图',
                    basicView: '基本视图',
                    mapView: '地图视图',
                },
            },
            'zh-Hant': {
                vendorListPage: {
                    title: '供應商',
                    addVendor: '添加供應商',
                    advancedView: '高級視圖',
                    basicView: '基本視圖',
                    mapView: '地圖視圖',
                },
            },
        },
    },
    data() {
        return {
            // advancedView: false,
            // isInitialAdvancedViewSet: false,  // set true once we resolve what it should be - used to hide both lists until we know which to use, otherwise there are extra queries
            preferAdvancedLocalStorageKey: 'vendorListTypePreferAdvanced',  // keep for now, we fall back to this if new one is not set
            // now with multiple modes -- advanced, basic, map -- we will fall back to the advanced view toggle if new stuff is not set
            viewModes: [
                ADVANCED_VIEW_MODE,
                MAP_VIEW_MODE,  // we want advanced and map next to each other, they are both 'wide'
                BASIC_VIEW_MODE,
            ],
            currentViewMode: null,  // will be the full object
            // currentViewModeKey: ADVANCED_VIEW_MODE.key,  // 'advanced' | 'basic' | 'map' - for now we will just toggle between advanced and basic, but we can add a map view later
            // isViewModeReady: false,  // to track if we've set the view mode based on local storage yet -- are we ready to show the view?
            preferredViewModeLocalStorageKey: 'vendorListPreferredViewMode',
        }
    },
    computed: {
        canAddVendor() {
            // TODO - base this on new backend permissions -- current front-end hiding is short-term
            return this.$currentUserInfo?.is_paid_seat || this.$tenantInfo.custom_flags?.all_internal_can_create_vendors || false;
        },
    },
    mounted() {
        this.getPreferredViewModeFromLocalStorage();
        this.isViewModeReady = true;
    },
    methods: {
        onResourceNewModal(resourceType) {
            if (!this.canAddVendor) {
                return;  // block if called from the empty list button
            }
            this.$refs.modal.new({ type: resourceType });
        },
        onResourceSaved() {
            if (this.$refs.basicList) {
                this.$refs.basicList.refreshList(true);
            }
            // TODO - refresh object grid when in advanced view
        },
        // toggleAdvancedView() {
        //     // TODO - save this setting to local storage (browswer local storage)
        //     this.advancedView = !this.advancedView;
        //     this.setPreferAdvancedInLocalStorage();
        // },
        // // SET / GET FROM LOCAL STORAGE
        // setPreferAdvancedInLocalStorage() {
        //     const key = this.preferAdvancedLocalStorageKey;
        //     const preferAdvanced = JSON.stringify(this.advancedView);
        //     console.log('Setting preferAdvancedLocalStorageKey in local storage', key, preferAdvanced);
        //     localStorage.setItem(key, preferAdvanced);
        // },
        setViewMode(viewModeKey) {
            // only call this when setting it explicitly from user action, not when initializing from local storage
            const viewMode = this.viewModes.find(vm => vm.key === viewModeKey);
            if (!viewMode) {
                console.error('Invalid view mode key:', viewModeKey);
                return;
            }
            this.currentViewMode = viewMode;
            this.setPreferredViewModeInLocalStorage(viewMode.key);
        },
        setPreferredViewModeInLocalStorage(viewModeKey) {
            localStorage.setItem(this.preferredViewModeLocalStorageKey, viewModeKey);
        },
        getPreferredViewModeFromLocalStorage() {
            const preferredViewModeKey = localStorage.getItem(this.preferredViewModeLocalStorageKey); // null if its not set
            const prefferedViewMode = preferredViewModeKey ? this.viewModes.find(vm => vm.key === preferredViewModeKey) : null;
            if (prefferedViewMode) {
                this.currentViewMode = prefferedViewMode;
                return;  // return early... we are only using the new thing
            }
            // if we didn't have that set, check the old advanced view toggle key for backwards compatibility
            const preferAdvancedRaw = localStorage.getItem(this.preferAdvancedLocalStorageKey);
            if (preferAdvancedRaw) {
                const preferAdvanced = JSON.parse(preferAdvancedRaw);
                // that will be a boolean true/false, we can use that to set the view mode of advanced or basic in this fallback case
                this.currentViewMode = preferAdvanced ? {...ADVANCED_VIEW_MODE} : {...BASIC_VIEW_MODE};
            } else {
                console.log('No advanced view preference found in local storage');
                // if here, then we should just set a fallback default 
                this.currentViewMode = {...ADVANCED_VIEW_MODE};
            }
        },
        clearPreferredViewModeInLocalStorage() {
            localStorage.removeItem(this.preferredViewModeLocalStorageKey);
        },
    },
};
</script>
